// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file mlops/gauge_metric/gaugemetric.proto (package gauge_metric, syntax proto3)
/* eslint-disable */

import type { JsonObject } from "@bufbuild/protobuf";
import { RPC } from "../../runtime";

/**
 * @generated from message gauge_metric.GaugeMetricEventsRequest
 */
export type GaugeMetricEventsRequest = {
/**
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: repeated string event_types = 3;
 */
eventTypes?: string[];
/**
 * @generated from field: gauge_metric.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message gauge_metric.GaugeMetricEventsResponse
 */
export type GaugeMetricEventsResponse = {
/**
 * @generated from field: map<string, google.protobuf.Struct> data = 1;
 */
data?: { [key: string]: JsonObject };
}
;
/**
 * @generated from message gauge_metric.GaugeMetricDailyStatRequest
 */
export type GaugeMetricDailyStatRequest = {
/**
 * @generated from field: string date = 1;
 */
date?: string;
}
;
/**
 * @generated from message gauge_metric.GaugeMetricDailyStatResponse
 */
export type GaugeMetricDailyStatResponse = {
/**
 * @generated from field: map<string, int32> stats = 1;
 */
stats?: { [key: string]: number };
}
;
/**
 * @generated from message gauge_metric.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc gauge_metric.MlopsGaugeMetricService.GetMlopsGaugeMetricTotalCount
 */
export const MlopsGaugeMetricService_GetMlopsGaugeMetricTotalCount = new RPC<GaugeMetricEventsRequest,GaugeMetricEventsResponse>("POST", "/getMlopsGaugeMetricTotalCount");
/**
 * @generated from rpc gauge_metric.MlopsGaugeMetricService.GetGaugeMetricDailyStats
 */
export const MlopsGaugeMetricService_GetGaugeMetricDailyStats = new RPC<GaugeMetricDailyStatRequest,GaugeMetricDailyStatResponse>("GET", "/getGaugeMetricDailyStats");
